import PropTypes from 'prop-types';

const CARGO_TYPE = {
  type: PropTypes.oneOf(['CARGO_TYPE_PASSENGER', 'CARGO_TYPE_CARGO']),
  default: 'CARGO_TYPE_PASSENGER',
};

export default CARGO_TYPE;
